import { Autocomplete, Avatar, Box, TextField } from '@mui/material'
import React, { FC } from 'react'
import { UserOption } from 'types'

interface SelectActiveUserProps {
  userOptions: UserOption[] // <-- array
  selectedUserOpt: UserOption | null // <-- nullable
  isUsersLoading: boolean
  setUserDash: React.Dispatch<React.SetStateAction<string | null>> // <-- allow null
}

const SelectActiveUser: FC<SelectActiveUserProps> = ({ userOptions, selectedUserOpt, isUsersLoading, setUserDash }) => {
  return (
    <Autocomplete<UserOption, false, false, false>
      size="small"
      sx={{ minWidth: 260, ml: 1 }}
      options={userOptions}
      value={selectedUserOpt}
      onChange={(_, v) => setUserDash(v?.id ?? null)}
      getOptionLabel={o => o?.label ?? ''}
      isOptionEqualToValue={(o, v) => o.id === v.id}
      loading={isUsersLoading}
      renderOption={(props, option) => {
        const { key, id, ...rest } = props
        return (
          <Box component="li" key={`${key}-${id}`} {...rest} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Avatar src={option.avatar ?? undefined} sx={{ width: 24, height: 24 }} />
            <span>{option.label}</span>
          </Box>
        )
      }}
      renderInput={params => (
        <TextField
          {...params}
          label="Viewing as"
          placeholder="Select user"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <Avatar src={selectedUserOpt?.avatar ?? undefined} sx={{ width: 22, height: 22, mr: 1 }} />
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
    />
  )
}

export default SelectActiveUser
